import { ChangeDetectorRef, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import {
  AccordionContentComponent,
} from '@sbd-account-portal/app/modules/dashboard/open-quote-requests-widget/drawer-content/accordion-content.component';
import {
  OpenQuoteRequestsItem,
} from '@sbd-account-portal/app/modules/dashboard/open-quote-requests-widget/quote-requests.types';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import {
  OpenQuoteRequestsWidgetService
} from '@sbd-account-portal/app/modules/dashboard/open-quote-requests-widget/open-quote-requests-widget.service';
import { TasksetsService } from '@sbd-account-portal/app/modules/tasksets/tasksets.service';
import { CathyService } from '@sbd-account-portal/app/services/cathy.service';
import { MainFuseDrawerService } from '@sbd-account-portal/app/modules/main-fuse-drawer/main-fuse-drawer.service';


@Component({
  selector: 'sbd-account-portal-frontend-open-quote-request-list-view',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    AccordionContentComponent,
  ],
  templateUrl: './open-quote-request-list-view.component.html',
})
export class OpenQuoteRequestListViewComponent {
  @Input() selectedQR: OpenQuoteRequestsItem | null = null;
  @Input() queuedQR: OpenQuoteRequestsItem[] = [];
  @Input() subtotal: number = 0;
  @Output() updatedOpenQREvent = new EventEmitter<OpenQuoteRequestsItem>();

  _fuseMediaWatcherService = inject(FuseMediaWatcherService);
  _openQuoteRequestsWidgetService = inject(OpenQuoteRequestsWidgetService);
  _taskSetService = inject(TasksetsService);
  _changeDetector = inject(ChangeDetectorRef);
  _cathyService = inject(CathyService);
  _mainFuseDrawerService = inject(MainFuseDrawerService)

  updateSelectedQuoteOption(event: OpenQuoteRequestsItem) {
    this.updatedOpenQREvent.emit(event);
  }


  closeParentDrawerActionEvent() {
    this._taskSetService.openRightSideDrawer.set(false);
  }

  getFileEvent($event) {
    const quoteRequestId = $event.quoteRequestId
    const file_id = $event.file_id

    this._openQuoteRequestsWidgetService.readFile(quoteRequestId, file_id).subscribe((r) => {
      if(!r.success){
        this._cathyService.error(r.message);
      }
    });
  }


  openMainDrawerEvent($event) {
    this._openQuoteRequestsWidgetService.selectedOpenQR.set($event.item)
    this._mainFuseDrawerService.openDrawer.set(true)
    this._mainFuseDrawerService.contentContext.set($event.context)
    this._changeDetector.detectChanges();
  }
}
